import type { FC, PropsWithChildren } from 'react';

import styles from './modal-content.module.scss';

export const ModalContent: FC<PropsWithChildren> = ({ children }) => <div className={styles.content}>{children}</div>;
